import React, { Component } from 'react'

import { withTranslation } from 'react-i18next'

import { servicesCommunicator } from '../../../../communicators/servicesCommunicator'

import { Page } from '../../../components/Page/Page'
import { PageInfo } from '../../../components/PageInfo/PageInfo'
import { AboutSection } from '../../../components/AboutSection/AboutSection'
import { SectionLinks } from '../../../components/SectionLinks/SectionLinks'
import { SectionsList } from '../../../components/SectionsList/SectionsList'

class ServiceDetails extends Component {
    constructor(props) {
        super(props)
        this.state = {
            service: null,
            isLoading: true
        }
    }

    componentDidMount() {
        this.loadService()
    }

    async loadService() {
        try {
            const { slug } = this.props.match.params

            const service = await servicesCommunicator.fetchSingleService(slug)

            this.setState({ service, isLoading: false })
        } catch (error) {
            console.error(error.message)
            this.setState({ isLoading: false })
        }
    }

    render() {
        const { t } = this.props
        const { service, isLoading } = this.state

        const serviceTitle = service && `${t('headTitle')}/${service.name}`
        const serviceDescription = service && service.sercviceDescription

        return (
            <Page isLoading={isLoading} title={serviceTitle} description={serviceDescription}>
                {service && (
                    <div className="service-details">
                        <PageInfo
                            breadcrumbs={t('serviceDetails.breadcrumbs')}
                            title={service.name}
                            bgImage="/images/usluge3.jpg"
                            overlay
                        />
                        <AboutSection
                            // title={service.name}
                            description={service.htmlDescription}
                            // split
                        />
                        <SectionLinks links={service.sectionLinks} dark />
                        <SectionsList sections={service.sections} />
                    </div>
                )}
            </Page>
        )
    }
}

export default withTranslation()(ServiceDetails)
